/* The vitrine's frame ornaments — the house's own geometry (girih, the
   لچک corner medallion), inline and `currentColor`, so one token themes them
   in light and dark. Server-rendered; nothing here is interactive. */

/** One لچک, drawn for the top-start corner; the other three are CSS mirrors. */
function Lachak({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 100 100" fill="none" aria-hidden focusable="false">
      <g stroke="currentColor" strokeLinejoin="round" vectorEffect="non-scaling-stroke">
        <path d="M0 0 H62 A62 62 0 0 1 0 62 Z" strokeWidth="1" />
        <path d="M0 0 H44 A44 44 0 0 1 0 44" strokeWidth=".7" opacity=".7" />
        <path d="M0 0 L30 12 L12 30 Z" strokeWidth=".7" />
        <path d="M22 0 L22 8 M0 22 L8 22" strokeWidth=".7" opacity=".6" />
        <circle cx="6" cy="6" r="2" fill="currentColor" stroke="none" />
      </g>
    </svg>
  );
}

/** The four corners of a framed picture — the vitrine's gilt frame. */
export function FrameCorners() {
  return (
    <span className="vt-corners" aria-hidden>
      <Lachak className="vt-corner vt-corner--ts" />
      <Lachak className="vt-corner vt-corner--te" />
      <Lachak className="vt-corner vt-corner--bs" />
      <Lachak className="vt-corner vt-corner--be" />
    </span>
  );
}

